import type { BaseHit } from 'instantsearch.js';
import type { CentPrecisionMoney, ProductBadgeV2, ProductPromotion, StyleProduct } from '../../codegen/types';
import { getCtLocale } from '../internationalization';
import { type ProductHitTypes } from './transformersUtils';

type Colors = {
  key: string;
  image: string;
  [k: string]: string;
};

export const createProductHit = ({ item, locale }: { item: BaseHit; locale: string }): ProductHitTypes => {
  const ctLocale = getCtLocale(locale);

  const {
    [`name.${ctLocale}`]: name,
    [`description.${ctLocale}`]: description,
    [`slug.${ctLocale}`]: slug,
    [`gender.${ctLocale}`]: gender,
    [`category.${ctLocale}`]: category,
    [`fastening.${ctLocale}`]: fastening,
    [`technologies.${ctLocale}`]: technologies,
    [`color.${ctLocale}`]: shortColor,
    [`mediumColor.${ctLocale}`]: mediumColor,
    [`merchandiseCategory.${ctLocale}`]: merchandiseCategory,
    [`rangeGroupDescription.${ctLocale}`]: rangeGroupDescription,
    [`brand.${ctLocale}`]: brand,
    [`productBadgesV2.${ctLocale}`]: productBadgesV2,
    [`styleName.${ctLocale}`]: styleName,
    price,
    wasPrice,
    thenPrice,
    objectID,
    image,
    images,
    colors,
    key,
    id,
    primaryCategory = {},
    promotion,
  } = item;

  const itemColors = colors as unknown as Colors[];
  const itemImages = images as unknown as string[];
  const transformedColors = itemColors
    ?.map((itemColor: Colors) => {
      const { key: colorKey, image: colorImage, [`color.${ctLocale}`]: localizedColor } = itemColor;
      return { key: colorKey, image: colorImage, color: localizedColor };
    })
    .filter((itemColor: StyleProduct) => itemColor.key !== objectID);
  const transformedImages = (itemImages && itemImages) || (image && [image]) || [' '];

  const { [`primaryCategory.${ctLocale}`]: primaryName, key: primaryKey } = primaryCategory as {
    [key: string]: string;
  };

  return {
    name: name as string,
    description: description as string,
    slug: slug as string,
    gender: gender as string[],
    category: category as string,
    fastening: fastening as string,
    technologies: technologies as string[],
    color: (mediumColor as string) || (shortColor as string),
    key: (key as string) || (id as string),
    price: price as CentPrecisionMoney,
    wasPrice: wasPrice as CentPrecisionMoney,
    thenPrice: thenPrice as CentPrecisionMoney,
    objectID: objectID as string,
    image: transformedImages as string[],
    colors: transformedColors as StyleProduct[],
    merchandiseCategory: merchandiseCategory as string,
    brand: brand as string,
    primaryCategory: {
      key: primaryKey || undefined,
      name: primaryName || undefined,
    },
    badgesV2: productBadgesV2 as ProductBadgeV2,
    styleName: styleName as string,
    rangeGroupDescription: rangeGroupDescription as string,
    promotion: promotion as ProductPromotion,
  };
};
